import apiInstance from './api';

const articleApi = apiInstance.injectEndpoints({
  endpoints: (build) => ({
    getArticleGroups: build.query({
      query: () => '/article_groups',
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['ArticleGroups'],
    }),
    getArticleTypes: build.query({
      query: () => '/article_types',
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['ArticleTypes'],
    }),
    /** İslam Ansiklopedisi (1. edisyon) maddelerinde başlık araması; `isTam` BE'nin dış servise ilettiği türdür. */
    searchE1Articles: build.query({
      query: ({ title, isTam = '' }) => ({ url: '/article_title_e1s', params: { title, isTam } }),
      transformResponse: (response) => response['hydra:member'],
    }),
    /**
     * Id'si bilinen 1. edisyon maddelerinin başlıklarını getirir: `{ [id]: 'BAŞLIK (slug)' }`. Getirilemeyen madde
     * sonuçta yer almaz; tek maddenin hatası diğerlerini düşürmez.
     */
    getE1ArticleTitles: build.query({
      async queryFn(ids, _api, _extraOptions, baseQuery) {
        const results = await Promise.all(ids.map((id) => baseQuery(`/article_title_e1s/${id}`)));
        const titles = results.reduce((map, { data }, index) => (data ? { ...map, [ids[index]]: `${data.title} (${data.slug})` } : map), {});
        return { data: titles };
      },
    }),
  }),
  overrideExisting: true,
});
export default articleApi;
